import { createContext, useContext, type ReactNode } from 'react';
import type { EvaluatedMap, EvaluatedValue } from './types';

const EMPTY: EvaluatedMap = new Map();
const EvalContext = createContext<EvaluatedMap>(EMPTY);

export function EvalProvider({
    value,
    children,
}: {
    value: EvaluatedMap;
    children: ReactNode;
}) {
    return <EvalContext.Provider value={value}>{children}</EvalContext.Provider>;
}

export function useEvaluated(characteristicId: number): EvaluatedValue {
    return useContext(EvalContext).get(characteristicId) ?? null;
}

/** Full evaluated map — useful for views that render multiple values
 *  (e.g. SummaryPanel iterating every visible Characteristic). */
export function useEvaluatedMap(): EvaluatedMap {
    return useContext(EvalContext);
}
